<template>
  <div class="sticky-navigation-bar">
    <button class="sticky-navigation-bar-chat_button" id="chat_btn_mob">Chat With Us</button>
    <!-- <a href="#" class="sticky-navigation-bar-chat_button">Chat With Us</a> -->
    <a href="tel:+1-513-817-3726" class="sticky-navigation-bar-call-button">
      <!-- <img src="@/assets/images/circle-phone.svg" style="margin-right: 10px;"/> -->
      Call Us</a>
    <button class="sticky-navigation-bar-quote-button" @click="onGetQuote">Get A Quote Now</button>
  </div>
</template>

<script>
// import EventBus from '@/utils/event-bus'
export default {
  props: {
    border: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      fullName: null,
      email: null,
      phoneNumber: null,
      courseName: null
    }
  },
  mounted: function () {
    window.addEventListener('scroll', event => {
      var note = document.getElementsByClassName('sticky-navigation-bar')[0]
      var scrollTop = document.documentElement.scrollTop
      if (scrollTop > 300) {
        note.style.display = 'flex'
      } else {
        note.style.display = 'none'
      }
    }, { passive: true })
  },
  methods: {
    onGetQuote: function () {
      if (this.$route.name !== 'Home') {
        this.$router.push('/')
        this.intervalId = setInterval(() => {
          if (window.pageYOffset > 50) {
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset + 100)
        }, 10)
      } else {
        this.intervalId = setInterval(() => {
          if (window.pageYOffset < 400) {
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset - 100)
        }, 10)
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .sticky-navigation-bar {
    background: var(--primary-yellow);
    padding: 10px 0px;
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(50px);
    z-index: 99999;
    display: none;

    &-chat_button, &-call-button, &-quote-button {
      border-radius: 6px;
      border: none;
      height: 46px;
      outline: none;
      padding: 0 10px;
      margin: 0 10px;
      font-size: 18px;
      cursor: pointer;
      transition: background-color 0.2s ease-out;
      text-decoration: none;
      font-family: 'ProximaNova-Bold';
      color: var(--primary-white);
      box-shadow: 5px 5px 0px rgb(0 0 0 / 15%);
      width: 33.333%;
    }

    &-quote-button {
      background-color: var(--primary-green);

      &:hover {
        background-color: var(--primary-green-hover);
      }
    }

    &-chat_button, &-call-button {
      background-color: var(--fb-blue);
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: var(--fb-blue-hover);
      }
    }
    @media #{$desktop} {
      display: none !important;
    }

    @media #{$lxs} {
      &-chat_button, &-call-button, &-quote-button {
        padding: 0 10px;
        font-size: 14px;
      }
    }
    @media #{$sxs} {
      box-sizing: border-box;
      padding: 10px 5px;
      &-chat_button, &-call-button, &-quote-button {
        margin: 0 4px;
        font-size: 13px;
        padding: 0;
        box-shadow: 3px 3px 0px rgb(0 0 0 / 15%);
      }
    }
  }
</style>
